import { Typography } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const PageTitle: FC<PropsWithChildren> = ({ children }) => (
    <Typography color="primary" variant="h1" gutterBottom>
        {children}
    </Typography>
);
export default PageTitle;
